import type { EffectsLevel } from "./ui-types";

/** Decorative presentation only; never changes mining or transaction state. */
export function getPresentationPolicy({ effects, reducedMotion = false, visible = true, mining = false }: {
  effects: EffectsLevel; reducedMotion?: boolean; visible?: boolean; mining?: boolean;
}) {
  const effectiveEffects = mining && effects === "ON" ? "LOW" : effects;
  return {
    effects: effectiveEffects,
    animate: visible && effectiveEffects !== "OFF" && !reducedMotion,
    fps: effectiveEffects === "LOW" ? 30 : 60,
  };
}
